import type { UserManagementModal } from '../commands/types';
import EditRolesDialog from './dialogs/EditRolesDialog';
import AddLoginDialog from './dialogs/AddLoginDialog';

type UserManagementDialogsProps = {
  modal: UserManagementModal | null;
  onClose: () => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
};

export const UserManagementDialogs = ({
  modal,
  onClose,
  onSuccess,
  onError,
}: UserManagementDialogsProps) => (
  <>
    <EditRolesDialog
      key={`edit-roles-${modal?.type ?? 'closed'}-${modal?.relationKeys.join(',') ?? ''}`}
      open={modal?.type === 'editRoles'}
      modal={modal}
      onClose={onClose}
      onSuccess={onSuccess}
      onError={onError}
    />
    <AddLoginDialog
      key={`add-login-${modal?.type ?? 'closed'}-${modal?.relationKeys.join(',') ?? ''}`}
      open={modal?.type === 'addLogin'}
      modal={modal}
      onClose={onClose}
      onSuccess={onSuccess}
      onError={onError}
    />
  </>
);
